<template>
  <div class="animated fadeIn">
    <b-row>
        <b-col sm xs="12" class="text-left mt-3">
         <b-card>
            <div slot="header">
              Consultation des <strong>opérations</strong>  
            </div> 
            <b-row class="form-group"> 
                <b-form-group>         
                  <b-input-group>
                    <!-- <span style="margin-left:3%;"></span>
                    <b-input-group-prepend><b-input-group-text>Date du</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="date" placeholder="Date du " v-model="date_setting.date_du"></b-form-input><span style="padding-left:1px;padding-right:1px;"></span>
                    <b-input-group-prepend><b-input-group-text>Au</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="date" placeholder="Date au" v-model="date_setting.date_au"></b-form-input><span style="padding-left:1px;padding-right:1px;"></span> -->
                    <span style="margin-left:0%;"></span>
                    <b-input-group-prepend><b-input-group-text>Date du</b-input-group-text></b-input-group-prepend>
                    <!-- <datepicker v-model="date_setting.date_du"></datepicker><span style="padding-left:1px;padding-right:1px;"></span> -->
                    <el-date-picker
                      v-model="date_setting.date_du"
                      type="date"
                      placeholder="Choisir une date"
                      format="dd/MM/yyyy"
                      :picker-options="pickerOptions1">
                    </el-date-picker><span style="padding-left:1px;padding-right:1px;"></span>
                    <!-- <b-form-input type="date" placeholder="Date du " id="date_du" v-model="serverParams.date_du"></b-form-input><span style="padding-left:1px;padding-right:1px;"></span> -->
                    <b-input-group-prepend><b-input-group-text>Au</b-input-group-text></b-input-group-prepend>
                    <el-date-picker
                      v-model="date_setting.date_au"
                      type="date"
                      placeholder="Choisir une date"
                      format="dd/MM/yyyy"
                      :picker-options="pickerOptions1">
                    </el-date-picker><span style="padding-left:1px;padding-right:1px;"></span>
                    <!-- Attach Right button -->
                    <b-input-group-append>
                        <b-button variant="primary" @click.prevent="loadItems()"><i class="fa fa-search"></i> Actualiser</b-button><span style="padding-left:6px;padding-right:1px;"></span>
                    </b-input-group-append>
                    <b-input-group-append>
                      <!-- <b-form-select id="basicSelect"
                        :plain="true"
                        :options="['--Regrouper par--','Entite','Agence', 'Guichet']"
                        v-model="print_option.group_by">
                      </b-form-select>
                      
                      <b-form-select id="basicSelect"
                        :plain="true"
                        :options="['---Formats---','PDF', 'XLS', 'CSV']"
                        v-model="print_option.format">
                      </b-form-select> -->
                      <select class="form-control" size="0" v-model="print_option.group_by">
                        <option value="--Regrouper par--" v-if="can('etat-option-guichet')" selected>--Regrouper par--</option>
                        <option value="Entite" v-if="can('etat-option-entite')">Entite</option>
                        <option value="Agence" v-if="can('etat-option-agence')">Agence</option>
                        <option value="Guichet" v-if="can('etat-option-guichet')">Guichet</option>
                      </select>
                      <select class="form-control" size="0" v-model="print_option.format">
                        <option value="PDF" selected>---Formats---</option>
                        <option value="PDF">PDF</option>
                        <option value="XLS">XLS</option>
                        <option value="CSV">CSV</option>
                      </select>
                      <button class="btn btn-success" @click.prevent="printOption()"><i class="fa fa-print"></i>  Imprimer</button><span style="padding-left:1px;padding-right:1px;"></span>
                    </b-input-group-append>
                    <!-- <b-button variant="primary"><i class="fa fa-file-csv"></i> CSV</b-button><span style="padding-left:1px;padding-right:1px;"></span> -->
                  </b-input-group>
                </b-form-group>
            </b-row>
          </b-card>
        </b-col>
    </b-row>
    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table :columns="columns" styleClass="vgt-table condensed bordered striped" :rows="rows" :pagination-options="pagination" :search-options="search"  :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        <!-- <router-link :to="'show/' + props.row.id"> -->
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                     
                                <router-link :to="'show/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/transferts/update/beneficiare/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/historique/operation/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                </router-link>
                                <b-dropdown-item-button aria-describedby="header2" @click.prevent="imprim(props.row.id)"><i class="fa fa-print"></i> Réimprimer le bordereau</b-dropdown-item-button>
                            </div>     
                          </b-dropdown>
                    </span>
                    <span v-else style="font-size: 0.875rem;">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      totalRecords :0,
      columns: [
        {
          label: 'Opérateur',
          field: 'user_nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Agence',
          field: 'agence_nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Guichet',
          field: 'guichet_nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Opération',
          field: 'typeoperation_code',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Type pièce',
          field: 'piece_libelle',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Nom',
          field: 'nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        
        {
          label: 'Prenom(s)',
          field: 'prenom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Adresse',
          field: 'adresse',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Téléphone',
          field: 'telephone',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'N° Pièce',
          field: 'num_piece',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant transfere',
          field: 'montant_transfere',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        
        {
          label: 'Montant TTC',
          field: 'montant_ttc',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Réliquat',
          field: 'reliquat',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Tarif',
          field: 'tarif',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Commission',
          field: 'montant_commission',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Taux Commissions (%)',
          field: 'taux_commission',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'TVA',
          field: 'montant_tva',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Taux TVA (%)',
          field: 'taux_tva',
          type: 'number',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Date d\'opération',
          field: 'date_operation',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      date_setting:{
        adresse: "",
          agence_nom: "",
          code_envoi: "",
          entite_nom: "",
          guichet_nom: "",
          id: "",
          montant_commission: "",
          montant_transfere: "",
          montant_ttc: "",
          montant_tva: "",
          nom: "",
          num_piece: "",
          num_transaction: "",
          piece_libelle: "",
          prenom: "",
          reliquat: "",
          rembourse: "",
          tarif: "",
          taux_commission: "",
          taux_tva: "",
          telephone: "",
          typeoperation_code: "",
          user_nom: "",
          date_du:'',
          date_au:'',
          nb_lines:10,
          typedepiece_id:'',
          group_by:'Guichet',
          format:'---Formats---',
          page:1,
          current_page: 1
      },
      print_option:{
        date_du:'',
        date_au:'',
        typedepiece_id:'',
        nb_lines:'',
        group_by:'Guichet',
        format:'---Formats---'
      }
    };
  },
  // computed: mapState({
  //   agencies: state => state.atm.all
  // }),
  created () {
    
    
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    get_all_mandates(){
        this.$store.dispatch('mandate/get_all_mandates_by_user',this.$route.params.guichet_id).then(()=>{
          return this.rows =  store.getters['mandate/rows'];
        })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async printOption(){
      this.print_option.date_du = this.date_setting.date_du
      this.print_option.date_au = this.date_setting.date_au
      this.print_option.nb_lines = 10
      let response = {}
      if (this.print_option.group_by.toLowerCase()=="entite"){
        response = await this.$store.dispatch('mandate/post_mandates_by_entite_imprim',this.print_option)
      }else if(this.print_option.group_by.toLowerCase()=="agence"){
        response = await this.$store.dispatch('mandate/post_mandates_by_agence_imprim',this.print_option)
      }else if(this.print_option.group_by.toLowerCase()=="guichet"){
        response = await this.$store.dispatch('mandate/post_mandates_by_guichet_imprim',this.print_option)
      }
      if(response.data != undefined){        
        console.log('Response is defined : '+JSON.stringify(response))
        window.open(response.data.content,'_blank')
      }else{
        console.log('Response not defined : '+ JSON.stringify(response))  
      }
    },
    async imprim(id){
        let response = await this.$store.dispatch('mandate/impression_operation',id)
        console.log(response)
        window.open(response.content, "_blank")
    },
    setting(){
      var q = new Date();
      var m = q.getMonth();
      var d = q.getDate();
      var y = q.getFullYear();
      var date = new Date(y, m, d);
      this.date_setting.date_au = this.date_setting.date_du=date
      this.date_setting.typedepiece_id = this.$route.params.typedepiece_id
      this.print_option.typedepiece_id = this.$route.params.typedepiece_id
      console.log("entity ",this.print_option.typedepiece_id)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.date_setting.page = params.currentPage
      this.updateParams({page: params.currentPage,current_page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.date_setting.nb_lines = params.currentPerPage
      this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
      });
      this.loadItems();
    },    
    onColumnFilter(params) {
      this.date_setting.adresse=params.columnFilters.adresse,
      this.date_setting.agence_nom=params.columnFilters.agence_nom,
      this.date_setting.code_envoi=params.columnFilters.code_envoi,
      this.date_setting.entite_nom=params.columnFilters.entite_nom,
      this.date_setting.guichet_nom=params.columnFilters.guichet_nom,
      this.date_setting.montant_commission=params.columnFilters.montant_commission,
      this.date_setting.montant_transfere=params.columnFilters.montant_transfere,
      this.date_setting.montant_ttc=params.columnFilters.montant_ttc,
      this.date_setting.montant_tva=params.columnFilters.montant_tva,
      this.date_setting.nom=params.columnFilters.nom,
      this.date_setting.num_piece=params.columnFilters.num_piece,
      this.date_setting.num_transaction=params.columnFilters.num_transaction,
      this.date_setting.piece_libelle=params.columnFilters.piece_libelle,
      this.date_setting.prenom=params.columnFilters.prenom,
      this.date_setting.reliquat=params.columnFilters.reliquat,
      this.date_setting.rembourse=params.columnFilters.rembourse,
      this.date_setting.tarif=params.columnFilters.tarif,
      this.date_setting.taux_commission=params.columnFilters.taux_commission,
      this.date_setting.taux_tva=params.columnFilters.taux_tva,
      this.date_setting.telephone=params.columnFilters.telephone,
      this.date_setting.typeoperation_code=params.columnFilters.typeoperation_code,
      this.date_setting.user_nom=params.columnFilters.user_nom,
      this.updateParams(params);
      this.loadItems();
    },
    // printOption(){
    //   console.log("parametrage : ",this.print_option)
    // },
    loadItems() { 
      this.$store.dispatch('mandate/post_mandates_by_typepiece_by_date_me',this.date_setting).then((response)=>{
          this.totalRecords = response.total;
          return this.rows =  store.getters['mandate/rows'];
      })
    }
  },
  mounted(){
    this.setting()
    this.loadItems()
  }
  
}
</script>
